<template>
  <div class="animated fadeIn">
    <component-header
      title="Payment History "
      @search-query="(val) => (filter = val)"
      :isLoading="loading"
      @reload-data="getCheckoutHistory"
      :hasback="false"
      :hasCreate="false"
    />
    <b-card class="card-wrap" border-variant="info" style="min-height: 450px">
      <b-row>
        <b-col md="3" class="my-1">
          <label>Time Period</label>
          <b-form-group label-cols-sm="3" class="mb-0">
            <eb-select
              type="select"
              v-model="selectedPeriod"
              :options="periodList"
              label="text"
              :id="'selecttime'"
              :selected="selectedPeriod"
              @input="changePeriod"
            ></eb-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1">
          <label>Provider</label>
          <b-form-group label-cols-sm="3" class="mb-0">
            <eb-select
              type="select"
              v-model="selectedProvider"
              :options="partnerList"
              label="partnerName"
              :id="'selectprovider'"
              placeholder="Select Provider"
              @input="changeProvider"
            ></eb-select>
          </b-form-group>
        </b-col>
      </b-row>
      <div>
        <b-table
          :fields="Columns"
          :items="historyData"
          :dark="false"
          :filter="filter"
          :hover="true"
          thead-class="header"
          :striped="false"
          :bordered="true"
          :current-page="currentPage"
          :per-page="perPage"
          :small="false"
          show-empty
          :fixed="false"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="createdAt" slot-scope="data">
            <div>{{ data.item.createdAt | formatedate }}</div>
          </template>
          <template slot="empty">
            <div v-if="loading" class="text-center">
              <span><b>Loading...</b></span>
            </div>
            <div v-else class="text-center">No data available.</div>
          </template>
        </b-table>
      </div>
      <div style="float: right">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="historyData.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentHeader";
import loader from "@/components/loader/nipigeloader.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "paymenthistory",
  components: {
    ebButton,
    ebSelect,
    loader,
    ComponentHeader,
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      filter: "",
      perPage: 10,
      sortBy: "createdAt",
      sortDesc: true,
      Columns: [
        {
          key: "payment.orderId",
          label: "Transaction ID",
        },
        {
          key: "payment.type",
          label: "Payment Type",
        },
        {
          key: "totalPrice",
          label: "Amount",
          sortable: true,
        },
        {
          key: "paymentStatus",
          label: "Payment Status",
        },
        // {
        //   key: "orderStatus",
        //   label: "Order Status"
        // },
        {
          key: "createdAt",
          label: "Date",
          sortable: true,
        },
      ],
      selectedPeriod: {
        text: "Last 7 days",
        value: 7,
      },
      selectedProvider: null,
      periodList: [
        {
          text: "Last 7 days",
          value: 7,
        },
        {
          text: "Last 15 days",
          value: 15,
        },
        {
          text: "Last 30 days",
          value: 30,
        },
        {
          text: "Last 3 Months",
          value: 90,
        },
        {
          text: "Last 6 Months",
          value: 180,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      historyData: "order/GetCheckoutHistory",
    }),
    partnerList() {
      let data = this.$store.getters["partner/GetPartnerLiteList"];
      if (data.length > 0) {
        let partners = [];
        data.map((obj) => {
          partners.push({ ...obj, partnerName: obj.organization.name });
        });
        return partners;
      }
    },
  },
  methods: {
    ...mapActions({
      GetPartnerList: "partner/fetchPartnerListLite",
    }),
    changePeriod(event) {
      this.getCheckoutHistory();
    },
    changeProvider() {
      this.getCheckoutHistory();
    },
    getCheckoutHistory() {
      this.loading = true;
      let payload = {
        days: this.selectedPeriod.value,
        provider: this.selectedProvider ? this.selectedProvider._id : "",
      };
      this.$store
        .dispatch("order/fetchCheckoutHistory", payload)
        .then((data) => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    let data = this.historyData;
    if (!data || data.length === 0) {
      this.getCheckoutHistory();
      this.GetPartnerList({ type: "" });
    }
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
};
</script>

<style>
table.b-table[aria-busy="true"] {
  opacity: 0.6;
}
</style>
